import { Box, Divider, Stack } from '@mui/material';

import { ExternalInvitation } from '@/domain/external-invitation/entities/external-invitation.entity';
import { InviteCategory } from '@/domain/external-invitation/entities/invitation-category';
import { Sector } from '@/domain/impact/impact.entity';

import { ExternalInvitationsList } from './components/ExternalInvitationsList';
import {
  FormExternalInvite,
  InviteSubmitData,
} from './components/FormExternalInvite';

export function AssignExternalView({
  sector,
  categories,
  existingInvitations,
  onSubmitInvite,
}: {
  sector: Sector;
  categories?: InviteCategory[];
  existingInvitations: ExternalInvitation[];
  onSubmitInvite: (data: InviteSubmitData) => void;
}) {
  return (
    <Stack direction={'column'}>
      <Box>
        <FormExternalInvite
          sector={sector}
          categories={categories}
          onSubmitInvite={onSubmitInvite}
        />
      </Box>
      <Divider />
      <Box>
        <ExternalInvitationsList invitations={existingInvitations} />
      </Box>
    </Stack>
  );
}
